var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalapplicants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1551 30.9632C10.3256 32.648 2.90673 36.0883 7.42533 40.3933C9.63263 42.4961 12.091 44 15.1817 44H32.8182C35.909 44 38.3674 42.4961 40.5746 40.3933C45.0932 36.0883 37.6744 32.648 34.8448 30.9632C28.2096 27.0122 19.7904 27.0122 13.1551 30.9632Z",
    stroke: "#2E2D7E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 13C33 17.9706 28.9706 22 24 22C19.0294 22 15 17.9706 15 13C15 8.02944 19.0294 4 24 4C28.9706 4 33 8.02944 33 13Z",
    stroke: "#2E2D7E",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalapplicants);
export default __webpack_public_path__ + "static/media/totalapplicants.3dc91b55b8ec786b082b48bd6b8c52fd.svg";
export { ForwardRef as ReactComponent };